/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Row, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import * as XLSX from 'xlsx';
import ResizableDataTable from '../../../Tables/ResizableTable/components/ResizableReactTable';

const ShowTaxReport = ({ modalData, tableHeaderData }) => {
    const handleDownload = () => {
        if (!modalData?.length) return;

        // Create a new workbook
        const wb = XLSX.utils.book_new();
        
        // Create headers array from tableHeaderData
        const headers = tableHeaderData?.map(col => col.Header) || [];
        
        // Create data array with only the fields specified in tableHeaderData
        const worksheetData = modalData?.map(row => {
            const filteredRow = {};
            tableHeaderData?.forEach(col => {
                filteredRow[col.Header] = row[col.accessor];
            });
            return filteredRow;
        }) || [];
        
        // Convert data to worksheet format with proper headers
        const ws = XLSX.utils.json_to_sheet(worksheetData, { header: headers });
        
        // Add worksheet to workbook
        XLSX.utils.book_append_sheet(wb, ws, 'report');
        
        // Write the file
        XLSX.writeFile(wb, 'tax_report.xlsx');
    };
   return (
    <Row style={{ position: 'relative' }}>    
        <div className="ExcelTable" id='dvTable'>
             <Button 
                    disabled={!modalData?.length}
                    className="download-monthly-sub-order-report btn-primary btn btn-sm"
                    onClick={handleDownload}
                >
                    Download
                </Button>            
        </div>
    
        {modalData?.length ? (
            <ResizableDataTable reactTableData={{ tableHeaderData }} data={modalData} />
        ): <div className="no-data">No data to display</div>}
    </Row>
       )
   };

ShowTaxReport.propTypes = {  
    modalData: PropTypes.array.isRequired,
    tableHeaderData: PropTypes.array.isRequired,    
};

export default ShowTaxReport;